import secureStorage from "./encrypt";
//console.log('process.env.REACT_APP_GETWAY_API>>>>>>>>>>>>>>>.')
export const API_URL = {
	GETWAY_API: process.env.REACT_APP_GETWAY_API,
	COMMON_GATEWAY_API: process.env.REACT_APP_GETWAY_API,
	REACT_APP_CALLING_TYPE: ['fav', 'triivco'].includes(process.env.REACT_APP_CALLING_TYPE) ? process.env.REACT_APP_CALLING_TYPE : secureStorage.getItem("entitySource"),
};

//console.log(secureStorage.getItem("entitySource in constant"));
//secureStorage.setItem("entitySource", 'fav-id')
export const IS_FAVORITE_APP = (secureStorage.getItem("entitySource") === 'fav-id') ? true : false;
export const IS_TRIIVCO_APP = (secureStorage.getItem("entitySource") === 'triv-id') ? true : false;
export const IS_EMP_APP = (secureStorage.getItem("entitySource") === 'emp-id') ? true : false;
export const IS_OTO_APP = (secureStorage.getItem("entitySource") === 'oto-in') ? true : false;

export const SETTING = {
	CRYPTO_KEY: "U*oDwrIU!B#QX37%#24",
	RESEND_OTP_TIME_IN_SECOND: 30,
};
export const MAKER_ROLE_ID = 1;
export const CHECKER_ROLE_ID = 2;
export const APPROVER_ROLE_ID = 4;
export const TL_ROLE_ID = 4;
export const FINANCE_TEAM_ROLE_ID = 5;
export const OPS_TEAM_ROLE_ID = 6;
export const DATE_FORMAT = "dd mmm yyyy, HH:MM";
export const DATE_FORMAT_DMY = "dd mmm yyyy";
export const DATE_FORMAT_INPUT = "yyyy-MM-dd";
export const DATE_FORMAT_YMD = "yyyy-mm-dd";
export const DATE_FORMAT_MDY = "mmm dd, yyyy";
export const DATE_FORMAT_INPUT_TIME = "yyyy-MM-dd h:mm aa";
export const DATE_FORMAT_FULL = "dd mmm yyyy, HH:MM TT";

export const DATE_FORMAT_FILTER = "yyyy-mm-dd";

export const PAYMENT_TYPE = [
	{ value: "disbursal", label: "Disbursal" },
	{ value: "refund", label: "Refund" }
];
export const SPLIT_PAYMENT_TYPE = [
	{ value: "main_dealer", label: "Dealer Payment" },
	{ value: "split_dealer", label: "Split Payment" },
	{ value: "split_dealer2", label: "Split Payment2" },
	{ value: "agent_fee", label: "Agent Fee" },
	{ value: "referral_agent", label: "Referral Agent" },
	{ value: "agent_incentive", label: "Agent Incentive" },
	{ value: "onhold_dealer", label: "Onhold Dealer Payment" },
	{ value: "aro_fee", label: "ARO Fee" },
	{ value: "daily_bonus", label: "Daily Bonus" },
	{ value: "bm_fee", label: "BM Fee" },
	{ value: "bro_fee", label: "BRO Fee" },
	{ value: "onhold_agent", label: "Onhold Agent Payment" },
	{ value: "platinum_incentive", label: "Platinum Agent Incentive" },
	{ value: "take_over_amount", label: "Take Over Payment" },
	{ value: "customer_payment", label: "Customer Payment" },
];
export const PAYMENT_ORDER = ['main_dealer', 'split_dealer', 'split_dealer2', 'referral_agent', 'agent_fee', 'agent_incentive', 'bm_fee', 'bro_fee'];
export const IS_NUMBER_VALIDATION = /^[0-9]*$/;

export const REQUEST_PAYMENT_TYPE = {
	"Normal": "Payment will be made to dealer once the amount is received from the Financier",
	"Ad-Hoc": "Payment need to be made to dealer within 1 hour of request generation",
	"Advance": "Payment need to be made to dealer by today only or in the next batch of payment requests",
	"SFAP": "Payment need to be made to dealer as soon as the request gets generated",
}
export const REQUEST_PAYMENT_TYPES = [
	{ value: "normal", label: "Normal" },
	{ value: "ad_hoc", label: "Ad-Hoc" },
	{ value: "advance", label: "Advance" }
]

export const PAYMENT_REQUEST_TYPE = [
	{ value: "Normal", label: "Normal", entity_type: ['oto', 'fav', 'triv', 'emp'] },
	{ value: "Ad-Hoc", label: "Ad Hoc", entity_type: ['oto', 'fav', 'triv', 'emp'] },
	{ value: "Advance", label: "Advance", entity_type: ['oto', 'fav', 'triv', 'emp'] },
	{ value: "SFAP", label: "SFAP", entity_type: ['oto', 'fav', 'triv'] }
]
export const displayAmount = (amount) => {
	let amount2display = `IDR ${amount}`;
	return amount2display;
};

export const REPORT_DATE_TYPE = [
	{ value: 'weekly', label: 'Weekly' },
	{ value: 'monthly', label: 'Monthly' },
	{ value: 'quarterly', label: 'Quarterly' },
	{ value: 'half_yearly', label: 'Half Yearly' },
	{ value: 'custom_date', label: 'Custom Date' }
];
export const CURRENCY_INFO = {
	"PARENT_CURRENCY": "IDR",
	"CURRENT_CURRENCY": "IDR",
	"FROM_CURRENCY": "IDR",
	"TO_CURRENCY": "USD",
	"CONVERSION_RATE": 1
};
export const statusList = { 'disbursement_done': 'Disbursement Done', 'paid_to_dealer': "Paid to Dealer", 'refund_received': "Refund Received", 'disbursal_received': "Disbursal Received" };
export const statusArr = [
	{ value: 'paid_to_dealer', label: 'Paid to Dealer', lead_source: ['finance'] },
	{ value: 'refund_received', label: 'Refund Received', lead_source: ['finance'] },
	{ value: 'paid_to_dealer', label: 'Paid to Customer', lead_source: ['refinance', 'bikerefinance'] },
	{ value: 'refund_received', label: 'Bonus Received', lead_source: ['refinance', 'bikerefinance'] },
	{ value: 'disbursal_received', label: 'Disbursal Received', lead_source: ['finance'] },
];

// manage menu Permission for Roles 
export const hasAccessPermission = (modulename, page = 'view') => {
	const userAccess = secureStorage.getItem("userAccess");
	let Permission = userAccess && userAccess[modulename] && userAccess[modulename][page] == "1" ? true : false;

	return Permission;
};

export const maxDATE = (from_date, d = 0) => {
	var date = new Date(from_date);
	var lastDay = new Date(date.getFullYear(), date.getMonth() + d);
	return lastDay
}
export const PRODUCT_TYPE_ALL = [
	{ name: 'UCF', value: "finance", label: 'Used Car Finance' },
	{ name: 'UCRF', value: "refinance", label: 'Used Car Refinance' },
	{ name: 'UBRF', value: "bikerefinance", label: 'Used Bike Refinance' }
];

export const BUSINESS_LINE_FOR_MONTHLY_PAYOUT = [
	{ name: 'UCF', value: "ucf", label: 'Used Car Finance' },
	{ name: 'UCRF', value: "ucrf", label: 'Used Car Refinance' },
	{ name: 'UBRF', value: "ubrf", label: 'Used Bike Refinance' },
	{ name: 'INSURANCE', value: 'insurance', label: 'Insurance' },
	{ name: 'CLASSIFIEDS', value: 'classifieds', label: 'Classifieds' },
	{ name: 'BURSA', value: 'bursa', label: 'Bursa' },
	{ name: 'IF', value: 'if', label: 'IF' }
];

export const PRODUCT_TYPE = (IS_FAVORITE_APP)
	? PRODUCT_TYPE_ALL.filter(data => ['UCF', 'UCRF'].includes(data.name))
	: (IS_TRIIVCO_APP) ? PRODUCT_TYPE_ALL.filter(data => data.name === 'UCF') : IS_EMP_APP ? PRODUCT_TYPE_ALL.filter(data => ['UCRF'].includes(data.name)) : PRODUCT_TYPE_ALL;

export const FAM_ALLOWED_DOC_CATEGORY = [13, 14, 60, 61, 62, 17, 64, 18, 15, 51, 16, 52, 19, 53, 54, 58, 105, 106];
export const UNWIND_ARRAY = function (arr, by) {
	var results = [];
	arr.forEach(function (subArray) {
		let obj = { ...subArray };
		delete obj[by];
		if (subArray[by].length) {
			subArray[by].forEach(function (item) {
				item = { [by]: item, ...obj };
				results.push(item);
			});
		}
		else {
			subArray[by] = {};
			results.push(subArray);
		}
	});
	return results;
};
export const PRODUCT_TYPE_OBJECTS_ALL = {
	"finance": 'UCF',
	"refinance": 'UCRF',
	"bikerefinance": 'UBRF'
};

export const PRODUCT_TYPE_OBJECTS_UCRF = {
	"refinance": 'UCRF',
	"finance": 'UCF',
};

export const PRODUCT_TYPE_OBJECTS_UCF = {
	"finance": 'UCF'
};

export const PRODUCT_TYPE_OBJECTS = (IS_FAVORITE_APP) ? PRODUCT_TYPE_OBJECTS_UCRF : (IS_TRIIVCO_APP) ? PRODUCT_TYPE_OBJECTS_UCF : PRODUCT_TYPE_OBJECTS_ALL;
export const MAX_ADDITIONAL_REVENUE_SPLIT = 6;
export const DATE_FORMAT_MY = 'MM/yyyy';

export const AMOUNT_FORMAT_TYPE = [
	{ value: 'en', label: 'Indian Accounting Standard System' },
	{ value: 'id', label: 'Indonesian Accounting Standard System' }
]
export const RECONCILATION_STATUS = [
	{ value: 'matched', label: 'Matched' },
	{ value: 'notmatched', label: 'Not Matched' },
	{ value: 'duplicate', label: 'Duplicate' },
	{ value: 'manualmatched', label: 'Manual Matched' },
	{ value: 'duplicatematched', label: 'Duplicate Matched' },
];
export const RECONCILATION_EXTENDED_DAYS = 2;
export const SPLIT_PAYMENT_TYPE_SOURCE_BASED = {
	finance: [
		{ value: "main_dealer", label: "Dealer Payment" },
		{ value: "split_dealer", label: "Split Payment" },
		{ value: "split_dealer2", label: "Split Payment2" },
		{ value: "agent_fee", label: "Agent Fee" },
		{ value: "referral_agent", label: "Referral Agent" },
		{ value: "onhold_dealer", label: "Onhold Dealer Payment" },
		{ value: "bm_fee", label: "BM Fee" },
		{ value: "bro_fee", label: "BRO Fee" }
	],
	refinance: [
		{ value: "main_dealer", label: "Dealer/Agent Incentive" },
		{ value: "agent_fee", label: "Agent Fee" },
		{ value: "referral_agent", label: "Referral Agent" },
		{ value: "onhold_agent", label: "Onhold Agent Payment" },
		{ value: "take_over_amount", label: "Take Over Payment" },
		{ value: "customer_payment", label: "Customer Payment" }
	],
	bikerefinance: [
		{ value: "main_dealer", label: "Dealer/Agent Incentive" },
		{ value: "agent_fee", label: "Agent Fee" },
		{ value: "referral_agent", label: "Referral Agent" }
	]
}

let curr_date = new Date();
let STATEMENT_ACTION_MAX_DATE = 31;
export const BANK_STATEMENT_OPERATIONAL_PERIOD = {
	minimum_date: new Date(curr_date.getFullYear(), curr_date.getMonth(), 1, 0, 0, 0),
	maximum_date: new Date(curr_date.getFullYear(), curr_date.getMonth(), STATEMENT_ACTION_MAX_DATE, 23, 59, 59),
};
export const TAX_VALUE = 1.09;/// 1.08
export const TAX_PPN = 11;/// 11%

export const OTHER_PAYMENT_TRANS_TYPE = [
	{ value: 1, label: 'Interest Amount', entity_source: ['oto-in', 'fav-id', 'triv-id', 'emp-id'] },
	{ value: 2, label: 'Other Payment', entity_source: ['oto-in', 'fav-id', 'triv-id', 'emp-id'] },
	{ value: 3, label: 'Reward', entity_source: ['oto-in', 'fav-id', 'triv-id', 'emp-id'] },
	{ value: 4, label: 'Sweep-out Transaction', entity_source: ['oto-in', 'fav-id', 'triv-id', 'emp-id'] },
	{ value: 5, label: 'Wrong Transfer', entity_source: ['oto-in', 'fav-id', 'triv-id', 'emp-id'] },
	{ value: 6, label: 'Excess Amount', entity_source: ['oto-in', 'fav-id', 'triv-id', 'emp-id'] },
	{ value: 7, label: 'Routing UTR', entity_source: ['oto-in'] },
	{ value: 8, label: 'Suspense Amount', entity_source: ['oto-in', 'fav-id', 'triv-id', 'emp-id'] }
];

// Radis
export const IS_REDIS = false;
export const SHOW_CAPTCHA = false  // process.env.REACT_APP_SHOW_CAPTCHA;
// console.log(process.env)

export const MONTHS = [
	{ value: 1, label: "January" },
	{ value: 2, label: "February" },
	{ value: 3, label: "March" },
	{ value: 4, label: "April" },
	{ value: 5, label: "May" },
	{ value: 6, label: "June" },
	{ value: 7, label: "July" },
	{ value: 8, label: "August" },
	{ value: 9, label: "September" },
	{ value: 10, label: "October" },
	{ value: 11, label: "November" },
	{ value: 12, label: "December" },
];
export const PO_DOC_CATEGORY = [13, 63, 39, 7, 59];
export const BKPB_DOC_CATEGORY = [68, 66, 65];
export const PO_BKPB_DOC_CATEGORY = [13, 63, 39, 7, 59, 68, 66, 65];

export const FINANCIER_IDS_TO_EXCLUDE_WALLET = [17];

export const XENDIT_STATUS_TYPE = [
	{ value: "1", label: "In Progress" },
	{ value: "2", label: "Fail" },
	{ value: "3", label: "Success" }
];
export const PAYMENT_SOURCE_TYPE = {
	"carbay": 'Carbay',
	"merah": 'Merah',
	"manual_carbay": 'Manual Carbay',
	"manual_merah": 'Manual Merah',
	"others": 'Others',
	"pt_biru": 'PT-Biru',
	"manual_pt_biru": 'Manual PT-Biru',
	"manual": 'Manual'
};

export const SERVER_YEAR = [
	{ value: "2020", label: "2020" },
	{ value: "2021", label: "2021" },
	{ value: "2022", label: "2022" },
	{ value: "2023", label: "2023" },
	{ value: "2024", label: "2024" },
	{ value: "2025", label: "2025" },
	{ value: "2026", label: "2026" },
	{ value: "2027", label: "2027" },
	{ value: "2028", label: "2028" },
	{ value: "2029", label: "2029" },
	{ value: "2030", label: "2030" },
]

export const SERVER_MONTH = [
	{ value: "1", label: "January" },
	{ value: "2", label: "February" },
	{ value: "3", label: "March" },
	{ value: "4", label: "April" },
	{ value: "5", label: "May" },
	{ value: "6", label: "June" },
	{ value: "7", label: "July" },
	{ value: "8", label: "August" },
	{ value: "9", label: "September" },
	{ value: "10", label: "October" },
	{ value: "11", label: "November" },
	{ value: "12", label: "December" }
];


export const SALES_TASK_AGEING_DAYS = [
	{ id: 1, value: "3-5", label: "3-5 Days" },
	{ id: 2, value: "6-10", label: "6-10 Days" },
	{ id: 3, value: "11-30", label: "11-30 Days" },
	{ id: 4, value: "> 30", label: "> 30 Days" },
];

export const SALES_TASK_USER_ROLES = [
	{ id: 14, value: "Staff Coll", key: "Staff Coll" },
	{ id: 15, value: "Staff QA", key: "Staff QA" },
	{ id: 16, value: "TL Recon", key: "TL Recon" },
	{ id: 17, value: "TL Coll", key: "TL Coll" },
	{ id: 18, value: "Ast. Man", key: "Ast. Man" },
	{ id: 19, value: "HoAS", key: "HoAS" },
];
export const SERVICE_FEE_ALLOWED_FINANCER = [17, 6, 12];

export const REDIRECT_URLS = {
	"beta": "https://stage-sso.oto.com/google?redirect=",
	"preprod": "https://pre-sso.oto.com/google?redirect=",
	"local": "https://pre-sso.oto.com/google?redirect=",
	"prod": "https://sso.oto.com/google?redirect="
}

export const TAKE_OVER_TYPE = [
	{ value: "0", label: "No" },
	{ value: "1", label: "Yes" }
];

export const REDIRECT_URL = REDIRECT_URLS[process.env.REACT_APP_ENV];
export const SHOW_EMAIL_LOGIN_APP_TYPE = ['local', 'beta', 'preprod'];
export const SFA_ROLE_NAME_OTO = [
	{ value: 51, label: 'RBH' },
	{ value: 58, label: 'ZM' },
	{ value: 56, label: 'AM' },
	{ value: 52, label: 'BM' },
	{ value: 53, label: 'AGENT' },
	{ value: 54, label: 'BRO' },
	{ value: 57, label: 'ARO' },
	{ value: 50, label: 'VP' },
	{ value: 59, label: 'ARCO' }
];
export const FavouriteRoleMapping = [
	{ value: 52, label: 'MM' },
	{ value: 56, label: 'RM' },
	{ value: 58, label: 'ARM' },
	{ value: 60, label: 'AM' },]

export const RISK_CLASSIFICATION_QUESTIONS_MAPPING = {
	GREEN: ['BM_CALLING'],
	YELLOW: ['BM_CALLING', 'GIO_TAGGING_PICS'],
	ORANGE: ['BM_CALLING', 'GIO_TAGGING_PICS', 'CUSTOMER_CALLING'],
	RED: ['BM_CALLING', 'GIO_TAGGING_PICS', 'CUSTOMER_CALLING', 'AM_APPROVAL'],
};

export const QUESTION_TYPES = {
	YES_NO: 'yes_no',
	TEXT: 'text',
	TEXTARIA: 'textaria',
	FILE: 'file',
};

export const RISK_CLASSIFICATION_QUESTIONS = {
	BM_CALLING: [
		{
			question_id: 1,
			question_key: 'bm_calling_done',
			question: 'Have you done BM Calling?',
			type: QUESTION_TYPES.YES_NO,
		},
		{
			question_id: 2,
			question_key: 'bm_calling_result',
			question: 'Were the results of BM Calling positive?',
			type: QUESTION_TYPES.YES_NO,
			condition: (formData) => formData[1] === 'yes',
		},
		{
			question_id: 3,
			question_key: 'bm_calling_remarks',
			question: 'BM Calling Remarks',
			type: QUESTION_TYPES.TEXTARIA,
		},
	],
	GIO_TAGGING_PICS: [
		{
			question_id: 4,
			question_key: 'car_pics_clear',
			question: 'Are the car pictures clear?',
			type: QUESTION_TYPES.YES_NO,
		},
		{
			question_id: 5,
			question_key: 'car_good_state',
			question: 'Is the car in a good state?',
			type: QUESTION_TYPES.YES_NO,
			condition: (formData) => formData[4] === 'yes'
		},
		{
			question_id: 6,
			question_key: 'car_lat',
			question: 'Latitude',
			type: QUESTION_TYPES.TEXT,
			readonly: true,
		},
		{
			question_id: 7,
			question_key: 'car_long',
			question: 'Longitude',
			type: QUESTION_TYPES.TEXT,
			readonly: true,
		},
		{
			question_id: 8,
			question_key: 'car_displacement',
			question: 'Disp. from Dealer (in KM)',
			type: QUESTION_TYPES.TEXT,
			readonly: true,
		},
		{
			question_id: 9,
			question_key: 'geo_location_proceed',
			question: 'Is it okay to proceed with the shared geo-location?',
			type: QUESTION_TYPES.YES_NO,
			condition: (formData) =>
				formData["6"] &&
				formData["7"] &&
				formData["8"],
		},
		{
			question_id: 10,
			question_key: 'car_pics_remarks',
			question: 'Car Pics/Location Remarks',
			type: QUESTION_TYPES.TEXTARIA,
		},
	],
	CUSTOMER_CALLING: [
		{
			question_id: 11,
			question_key: 'customer_received_car',
			question: 'Has the customer received the car?',
			type: QUESTION_TYPES.YES_NO,
		},
		{
			question_id: 12,
			question_key: 'customer_car_good',
			question: 'Is the car in good condition?',
			type: QUESTION_TYPES.YES_NO,
			condition: (formData) => formData['11'] === 'yes',
		},
		{
			question_id: 13,
			question_key: 'customer_calling_remarks',
			question: 'Customer Calling Remarks',
			type: QUESTION_TYPES.TEXTARIA,
		},
	],
	AM_APPROVAL: [
		{
			question_id: 14,
			question_key: 'am_approval_doc',
			question: 'Upload AM Approval Doc',
			type: QUESTION_TYPES.FILE,
		},
		{
			question_id: 15,
			question_key: 'am_approval_remarks',
			question: 'AM Approval Remarks',
			type: QUESTION_TYPES.TEXTARIA,
		},
	],
};

export const TDP_FINANCER_IDS = 2008;
export const FID_DOC_CAT = 74;
export const BUSINESS_TYPE = (IS_FAVORITE_APP) ? 'fav' : IS_TRIIVCO_APP ? 'triv' : IS_EMP_APP ? 'emp' : 'oto';

export const BCA_STATUS_LIST = [
	{ label: 'Pending', value: 'PENDING', is_elegible_for: ['agent'] },
	{ label: 'Fail', value: 'FAIL', is_elegible_for: ['agent'] },
	{ label: 'Success', value: 'SUCCESS', is_elegible_for: ['agent'] },
	{ label: 'N/A', value: 'OTHER', is_elegible_for: ['dealer', 'other'] },
];
export const taging = {
	"jr_bro": "JR BRO",
	"sr_bro": "Sr BRO",
	"bro": "BRO",
	"fixed_income_bro_1": "BRO Fixed income 1",
	"fixed_income_bro_2": "BRO Fixed income 2",
	"fixed_income_bro_3": "BRO Fixed income 3"
}

export const GET_ROLE_ID_BY_TYPE = (roleType) => {
	let selectedEntity = secureStorage.getItem("entitySource") || 'oto-in';
	let roleIdMapping = {
		"oto-in": {
			maker: 1,
			checker: 2,
			approver: 4,
			finance_team: 5,
			ops_team: 6,
			cbi_access_role: 77,
			edited_loan_approver: 70,
			hrf_maker: 92,
			hrf_approver: 93
		},
		"emp-id": {
			maker: 1,
			checker: 2,
			approver: 4,
			finance_team: 5,
			ops_team: 6,
			sales_incentive_maker: -1,
			sales_incentive_approver: -1,
			cbi_access_role: 77,
			edited_loan_approver: 70,
			hrf_maker: -1,
			hrf_approver: -1
		},
		"fav-id": {
			maker: 22,
			checker: 23,
			approver: 25,
			finance_team: 26,
			ops_team: 27,
			sales_incentive_maker: 96,
			sales_incentive_approver: 97,
			cbi_access_role: 79,
			edited_loan_approver: 71,
			hrf_maker: 94,
			hrf_approver: 95
		},
		"triv-id": {
			maker: 54,
			checker: 55,
			approver: 57,
			finance_team: 58,
			ops_team: 59,
			sales_incentive_maker: 74,
			sales_incentive_approver: 75,
			cbi_access_role: 78,
			edited_loan_approver: 72,
			hrf_maker: -1,
			hrf_approver: -1
		}
	}
	return roleIdMapping[selectedEntity][roleType];
}

export const ROUTING_UTR_ENTITY_LIST = [
	{ value: "fav", label: "FAV" },
	{ value: "emp", label: "EMP" },
	{ value: "triv", label: "TRIV" },
	{ value: "oto", label: "OTO" }
]
export const MANUAL_PAYMENT_SOURCE_MAP = {
	carbay: "manual_carbay",
	merah: "manual_merah",
	pt_biru: "manual_pt_biru", // explicitly added
};

export const DPD_CASES = [
	{ value: "1", label: "Yes", entity_type: ['oto'] },
	{ value: "0", label: "No", entity_type: ['oto'] },
]

export const BM_ROLE_ID = 52;

export const CBI_DROP_DOWN = () => {
	const lang = secureStorage.getItem("lang");
	return [
		{ value: "1", label: (lang === 'en' ? "No Credit History" : "Tidak memiliki riwayat kredit"), status: 0 },
		{ value: "2", label: (lang === 'en' ? "Performing loan" : "lancar"), status: 0 },
		{ value: "3", label: (lang === 'en' ? "Under Special Mention" : "Dalam perhatian khusus"), status: 0 },
		{ value: "5", label: (lang === 'en' ? "Kol 1 - Pass" : "Kol 1 - Lancar"), status: 1 },
		{ value: "6", label: (lang === 'en' ? "Kol 2 - Special Mention" : "Kol 2 - Dalam Perhatian Khusus"), status: 1 },
		{ value: "7", label: (lang === 'en' ? "Kol 3 - Substandard" : "Kol 3 - Kurang Lancar"), status: 1 },
		{ value: "8", label: (lang === 'en' ? "Kol 4 - Doubtful" : "Kol 4 - Diragukan"), status: 1 },
		{ value: "9", label: (lang === 'en' ? "Kol 5 - Loss" : "Kol 5 - Macet"), status: 1 },
		{ value: "4", label: (lang === 'en' ? "Other" : "Other"), status: 1 },
	];
}

export const REQUEST_RESPONSE_ENCRYPTION = {
	response_aes_key: process.env.REACT_APP_RESPONSE_AES_KEY,
	publicKey: process.env.REACT_APP_PUBLIC_KEY
};

export const SKIP_ENCRYPTION_ROUTE_KEYWORDS = [
	'login',
	'refresh-token',
	'public',
	'docs_upload',
	'user'
];

export const EDIT_LOAN_TRANCH_TYPE = [
	"agent_dynamic_booster_adjustment",
	"dealer_dynamic_booster_adjustment",
	"aro_dynamic_booster_adjustment",
	"bm_dynamic_booster_adjustment",
	"po_refund_adjustment",
	"bro_dynamic_booster_adjustment",
	"fixed_aro_dynamic_booster_adjustment",
]
export const searchTypeOptions = [
	{ label: "Loan Id", value: "loan_id" },
	{ label: "User Id", value: "user_id" }
];

export const sortoption = [
	{ label: "Loan Count", value: "loan_count" },
	{ label: "Incentive Amount", value: "incentive_amount" }
]

export const UPLOAD_STATUS = {
	PENDING: 'Pending',
	PENDING_APPROVAL: 'Pending Approval',
	REJECTED: 'Rejected',
	APPROVED: 'Approved',
	REUPLOAD_PROCESSED: 'Reupload Processed',
	REUPLOAD_PENDING_APPROVAL: 'Reupload Pending Approval',
	REUPLOAD_REJECTED: 'Reupload Rejected',
	REUPLOAD_APPROVED: 'Reupload Approved',
	REUPLOAD_REQUIRED: 'Reupload Required',
	ALL_LOANS_LOST_APPROVAL_PENDING: 'All Loan Lost - Approval Pending',
	AUTO_DEDUCTION_FOR_LAD_APPROVED: "Auto Deduction For Lad Approved",
	BPJS_UPLOADED: "BPJS Uploaded",
	APPROVED_BPJS: "Approved Bpjs",
	PENDING_BPJS_APPROVAL: "Pending Bpjs Approval",
	BPJS_REJECTED: "BPJS Rejected"
};
export const sort = [
	{ label: "ASC", value: "ASC" },
	{ label: "DESC", value: "DESC" }
];

export const statusOptions = [
	{ id: 'PENDING', name: 'PENDING' },
	{ id: 'PENDING_APPROVAL', name: 'PENDING APPROVAL' },
	{ id: 'REJECTED', name: 'REJECTED' },
	{ id: 'APPROVED', name: 'APPROVED' },
	{ id: 'REUPLOAD_PROCESSED', name: 'REUPLOAD PROCESSED' },
	{ id: 'REUPLOAD_PENDING_APPROVAL', name: 'REUPLOAD PENDING APPROVAL' },
	{ id: 'REUPLOAD_REJECTED', name: 'REUPLOAD REJECTED' },
	{ id: 'REUPLOAD_APPROVED', name: 'REUPLOAD APPROVED' },
	{ id: 'REUPLOAD_REQUIRED', name: 'REUPLOAD REQUIRED' },
	{ id: 'ALL_LOANS_LOST_APPROVAL_PENDING', name: 'ALL LOANS LOST APPROVAL PENDING' },
	{ id: 'AUTO_DEDUCTION_FOR_LAD_APPROVED', name: 'AUTO DEDUCTION FOR LAD APPROVED' },
];

export const sampleDataForIncentivepayment = [
	{
		Entity: "Triivco",
		LoB: "UCF",
		"Loan Id": "1088",
		"Agent ID": "12367",
		"TOS Extra Incentive 0.4% UCF NIM": 299,
		"Extra ACC Incentive TOS": 4990,
		"Agent Extra Incentive": 200,
		"BM ID": "175",
		"BM Grade Allowance (PKWT)": 133456,
		"BM Allowance": 250,
		"BM BPJS KS": 350,
		"Extra ACC Incentive BM": 5600,
		"BM Self Submit Fee": 233,
		"BM Active Dealer Rewards": 4440,
		"BM WSI Rewards": 344.56,
		"BM NIM Incentive": 1234,
		"BM Extra Incentive": 45677,
		"AM ID": "8776",
		"AM Allowance": 2333,
		"AM Main Incentive": 456,
		"AM BPJS KS": 555,
		"AM WSI Rewards": 666,
		"TIPS AM": 3456,
		"AM Extra Incentive": 343
	}
];

export const paymentStatusLabel = {
	DEDUCTION_PENDING: 'Deduction Pending',
	DEDUCTION_COMPLETED: 'Deduction Completed',
	AUTO_DEDUCTION_FOR_LAD_CREATED: 'Auto Deduction for Lad Created',
	AUTO_DEDUCTION_FOR_LAD_COMPLETED: 'Auto Deduction for Lad Completed'
};
export const ZOHO_LOGIN_REDIRECT_URL = process.env.REACT_APP_ZOHO_LOGIN_URL + "?redirect=";

export const REFUND_DISABLED_FINANCIER_IDS = [30, 14]

/** 🔹 TAB CONFIG BUILDER  */
export const TAB_ORDER = [
	"dealer",
	"customer",
	"car",
	"property_detail",
	"po",
	"do",
	"refund",
	"fid",
	"payment",
	"edited_loan"
];

export const WALLET_SOURCE_MAPPING = {
	'dealer': 'dealer',
	'agent': 'agent',
	'agent-carbay': 'agent',
	'agent-merah': 'agent',
	'agent-biru': 'agent'
}

export const WALLET_ENTITY_TYPE_MAPPING = {
	'dealer': 'carbay',
	'agent': 'pt_biru',
	'agent-carbay': 'carbay',
	'agent-merah': 'merah',
	'agent-biru': 'pt_biru',
	"carbay": "carbay",
	"merah": "merah"
}

export const WALLET_TYPE_MAPPING = {
	'dealer': 'carbay',
	'agent': 'carbay',
	'agent-carbay': 'carbay',
	'agent-merah': 'merah',
	'agent-biru': 'biru'
}
export const SFA_ROLE = {
	'rbh': 51,
	'bm': 52,
	'agent': 53,
	'bro': 54,
	'am': 56,
	'zm': 58,
	'aro': 57,
	'mm': 52,
	'rm': 56,
	'arm': 58,
	'amf': 60
}

export const sampleDataForFavouriteEntity = [
	{
		Entity: "Favorite",
		LoB: "UCRF",
		"Loan Id": "1020610",
		"MM ID": 306107,
		"MM Basic Salary": 100,
		"MM Main Incentive": 100,
		"MM Incentives NIM": 100,
		"MM BPJS Kes": 200,
		"AM ID": 306105,
		"AM Basic Salary": 100,
		"AM Main Incentive": 110,
		"AM Incentives NIM": 110,
		"AM Incentive MUF": 110,
		"AM Incentive Adira": 110,
		"KPI Allowance": 100,
		"AM BPJS Kes": 40,
		"ARM ID": 306104,
		"ARM Basic Salary": 100,
		"ARM Main Incentive": 100,
		"ARM NIM Incentive": 100,
		"ARM CM Allowance": 100,
		"ARM Fix Allowance": 100,
		"ARM BPJS Kes": 110,
		"RM ID": 306103,
		"RM Basic Salary": 100,
		"RM Main Incentive": 100,
		"RM NIM Incentive": 100,
		"RM MR Incentive": 100,
		"RM Fix Allowance": 100,
		"RM Fix Incentive": 100,
		"RM BPJS Kes": 100
	}
];

export const BUSINESS_UNIT = [
	{ value: "PRM", label: "PRM" },
	{ value: "PJB", label: "PJB" },
	{ value: 'FAV', label: 'FAV' }
]

export const ROUTING_BANK_ID = IS_FAVORITE_APP ? [74, 82, 106] : [87, 51, 109]